import React from "react";

// Reusable section heading with navy card-style header bar.
export function SectionTitle({ children, sub, testId }) {
  return (
    <div className="mb-5" data-testid={testId}>
      <h2 className="font-serif text-2xl font-bold text-[#0B2545] md:text-3xl">{children}</h2>
      {sub && <p className="mt-1 text-sm text-gray-600 md:text-base">{sub}</p>}
      <div className="mt-2 h-1 w-16 bg-[#FF9933]" />
    </div>
  );
}

export function CardHeader({ children }) {
  return (
    <div className="gov-card-header rounded-t-sm px-4 py-2.5 font-serif text-base font-bold">
      {children}
    </div>
  );
}
